var exports = {
  "cK": "AccessibilityTab.module__previewWrapper___YnZONk",
  "i1": "AccessibilityTab.module__previewContainer___YnZONk",
  "Eg": "AccessibilityTab.module__previewActionsRow___YnZONk",
  "vh": "AccessibilityTab.module__previewAvatarsRow___YnZONk",
  "R_": "AccessibilityTab.module__previewMessageContainer___YnZONk",
  "zf": "AccessibilityTab.module__ttsSection___YnZONk",
  "A6": "AccessibilityTab.module__ttsPreviewRow___YnZONk",
  "u5": "AccessibilityTab.module__ttsPreviewButton___YnZONk",
  "MN": "AccessibilityTab.module__ttsPreviewDescription___YnZONk",
};

module.exports = exports;
